import { type ReactNode } from 'react';

interface ErrorProps {
  children?: ReactNode;
}

const Error = ({ children = '' }: ErrorProps) => <span className="help-block invalid-feedback">{children}</span>;

export default Error;
